// RU-M3-D (M3-03): a paper option row whose premium came from the generated
// (mock) option chain, not live market data. Rows without the flag (legacy,
// unknown) show nothing.
export const SIMULATED_TOOLTIP = "Premium from a generated option chain, not live market data";

export default function SimulatedBadge({ title = SIMULATED_TOOLTIP, testid }) {
  return (
    <span
      data-testid={testid}
      title={title}
      className="inline-block text-[9px] font-section tracking-wide px-1.5 py-0.5 border border-amber-500/40 text-amber-300 bg-amber-500/10 whitespace-nowrap"
    >
      SIMULATED
    </span>
  );
}
